import { render, staticRenderFns } from "./RenwuList.vue?vue&type=template&id=6d74a91b&scoped=true"
import script from "./RenwuList.vue?vue&type=script&lang=js"
export * from "./RenwuList.vue?vue&type=script&lang=js"
import style0 from "./RenwuList.vue?vue&type=style&index=0&id=6d74a91b&prod&lang=less"
import style1 from "./RenwuList.vue?vue&type=style&index=1&id=6d74a91b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d74a91b",
  null
  
)

export default component.exports